"use client";

import { cn } from "@/lib/utils";

interface ListingShowMoreButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
}

export function ListingShowMoreButton({
  onClick,
  disabled,
  isLoading,
  className,
}: ListingShowMoreButtonProps) {
  return (
    <div className={cn("flex justify-center pt-2", className)}>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled || isLoading}
        className="text-brand-700 shrink-0 rounded-full border border-brand-500 bg-white px-6 py-2.5 text-sm font-semibold transition-colors hover:bg-gray-blue-50 disabled:cursor-not-allowed disabled:opacity-50">
        {isLoading ? "Loading..." : "Show more"}
      </button>
    </div>
  );
}
